<template>
  <Breadcrumbs
      title="Profile"
      :breadcrumbs="[
      { label: 'Profile', path: '' },
    ]"
  />

  <div class="container-fluid ">
      <div class="user-profile">
          <div class="row">
              <profileData />
          </div>
      </div>
  </div>
</template>

<script>
import profileData from "./profileData.vue";

export default {
    name: 'userProfile',
    components: {
      profileData,
    },
}
</script>
